<template>
  <div id="app" v-if="ready">
    <router-view />
  </div>
</template>

<script>
  import {
    Toast
  } from 'vant'
  export default {
    name: "App",
    data() {
      return {
        ready: false,
        isLoading: false,
      }
    },
    created() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      // We listen to the resize event
      window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
      var that = this;
      var _window = window
      if (process.env.NODE_ENV === 'development') {
        // 测试端数据
        that.$store.commit('setParams', {
          version: '1.0.0',
          bundle_id: 'com.hygame.qnboxaz',
          plat: 'ios',
          udid: 'b4e06c071349ef6a',
          app_key: 'fTTsyRqI6qS731tB'
        })
        that.$store.commit('setUserInfo', {
          accessToken: '725a53bd1efe47370dcf0aa792f07d1fdba1fdb5ad4ebb78ad',
          refreshToken: '725a53bd1efe47370dcf0aa792f07d1fdba1fdb5ad4ebb78ad'
        })
        that.$store.commit('isReady', true)
      } else {
        window.addEventListener(
          "flutterInAppWebViewPlatformReady",
          function (event) {
            try {
              _window.flutter_inappwebview.callHandler(
                "requestCommonParamFromWeb",
                ""
              );
            } catch (error) {
              console.log(error);
            }
            try {
              _window.flutter_inappwebview.callHandler("requestUserInfoFromWeb", "");
            } catch (error) {
              console.log(error);
            }
            _window["getCommonParamFromNative"] = function (data) {
              var result = JSON.parse(data);
              that.$store.commit("setParams", {
                version: result.version,
                bundle_id: result.bundle_id,
                plat: result.plat,
                udid: result.udid,
                app_key: result.app_key,
              });
            };
            _window["getUserInfoFromNative"] = function (data) {
              var result = JSON.parse(data);
              if (data) {
                that.$store.commit("setUserInfo", {
                  accessToken: result.accessToken,
                  refreshToken: result.refreshToken,
                  userId: result.userId
                });
              }
            };
            setTimeout(() => {
              that.$store.commit('isReady', true)
            }, 200)
          }
        );
      }
    },
    watch: {
      '$store.state.ready': {
        immediate: true,
        handler(e) {
          this.ready = e
        }
      }
    }
  };
</script>